// src
import config from "config";
import * as actions from "actions/search";
import { FETCHABLE_RESOURCES } from "config/constants";

const DEFAULT_STATE = {
  isLoading: false,
  results: {},
};

const processResults = (results) => {
  return FETCHABLE_RESOURCES.reduce((acc, { type, plural }) => {
    if (!results[plural]) return acc;
    return {
      ...acc,
      [type]: results[plural].map((r) => ({
        ...r,
        share: `${config.root}/light/${plural}/cs/${r.id}`,
        type,
      })),
    };
  }, {});
};

export default (state = DEFAULT_STATE, { type, payload }) => {
  // order actions by frequency
  switch (type) {
    case actions.searchRequest.toString(): {
      return { ...state, isLoading: true };
    }
    case actions.searchSuccess.toString(): {
      return {
        ...state,
        results: processResults(payload),
        isLoading: false,
      };
    }
    case actions.clearSearch.toString(): {
      return DEFAULT_STATE;
    }
    case actions.searchFailure.toString(): {
      return { ...state, isLoading: false };
    }
    default:
      return state;
  }
};
